// extracted by mini-css-extract-plugin
module.exports = {"control":"MapScaleControls_control__vrEFe","separator":"MapScaleControls_separator__0ImJT","zoomIn":"MapScaleControls_zoomIn__B6DX_","zoomOut":"MapScaleControls_zoomOut__A9KtQ"};